import React from 'react';

export interface FAQ {
  q: string;
  a: string;
}

interface FAQSectionProps {
  faqs: FAQ[];
}

export function FAQSection({ faqs }: FAQSectionProps) {
  return (
    <section className="mb-14">
      <h2 className="text-2xl font-serif font-bold text-foreground mb-6">
        Frequently asked questions
      </h2>
      <div className="space-y-3">
        {faqs.map((faq) => (
          <details
            key={faq.q}
            className="group rounded-lg border border-border bg-card p-4 sm:p-5"
          >
            <summary className="cursor-pointer list-none flex items-center justify-between gap-4">
              <h3 className="font-semibold text-foreground text-base">{faq.q}</h3>
              <span
                aria-hidden
                className="text-muted-foreground transition-transform group-open:rotate-45 text-xl leading-none"
              >
                +
              </span>
            </summary>
            <p className="mt-3 text-muted-foreground leading-relaxed">{faq.a}</p>
          </details>
        ))}
      </div>
    </section>
  );
}

export function buildFAQSchema(faqs: FAQ[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };
}
